import React, { FC, useMemo } from 'react';
import { hexToRgb } from 'src/helpers/styles';
import { SearchProfilesColorsDict } from 'src/helpers/constants';
import { IHighlightChunk, ISearchProfile } from 'src/pages/TenderPage/DocumentSearch/types';
import { ReactMarkdown } from 'src/common/Markdown';
import styles from '../index.module.scss';
import { useFilteredProfileTermsContext } from 'src/pages/TenderPage/DocumentSearch/hooks';

interface IProps {
  chunks: IHighlightChunk[];
  content: string;
  mainSearchProfile: ISearchProfile | null;
}

export const GeneratedPart: FC<IProps> = props => {
  const { chunks, content, mainSearchProfile } = props;
  const filteredProfileTerms = useFilteredProfileTermsContext();
  const isUnfiltered = useMemo(() => {
    return !filteredProfileTerms.some(profile => profile.terms.length > 0);
  }, [filteredProfileTerms]);
  const filteredTerms = useMemo(() => {
    if (isUnfiltered) {
      return [];
    }
    if (mainSearchProfile) {
      return (
        filteredProfileTerms.find(profile => !!mainSearchProfile && profile.searchProfile.id === mainSearchProfile.id)
          ?.terms || []
      );
    }
    //no main search profile in document mode
    return filteredProfileTerms.reduce((accumulator, current) => accumulator.concat(current.terms), [] as string[]);
  }, [filteredProfileTerms, isUnfiltered, mainSearchProfile]);

  const markdownContent = useMemo(() => {
    return chunks
      .map(chunk => {
        const { start, end, highlight } = chunk;
        const text = content.substr(start, end - start);
        const isMainProfile = !!mainSearchProfile && mainSearchProfile.color === highlight;
        const darkHighlight =
          (isMainProfile && isUnfiltered) || filteredTerms.some(term => term.toLowerCase() === text.toLowerCase());
        const backgroundColor =
          (highlight && hexToRgb(SearchProfilesColorsDict[highlight], darkHighlight ? 1 : 0.25)) || undefined;

        if (highlight) {
          return `<mark style="background: ${backgroundColor}">${text}</mark>`;
        } else {
          return text;
        }
      })
      .join('');
  }, [chunks, content, filteredTerms, isUnfiltered, mainSearchProfile]);

  return <ReactMarkdown className={styles.markdown}>{markdownContent}</ReactMarkdown>;
};

export default GeneratedPart;
